import { contentId } from '@uswitch/ev-utils/lib/contentful'
import { EVEntry } from '@uswitch/ev-core/react'

export const moduleEntity = (mod, extraData = {}) => {
  const props = { id: contentId(mod), entityId: contentId(mod), ...extraData }
  return props || {}
}

export const ContentfulModule = props => {
  console.log('LEGACY modules ContentfulModule', props)
  return <EVEntry {...props.entity} />
}

export const ContentfulModules = ({ modules = [], className, ...extraData }) => {
  if (!Array.isArray(modules)) return null
  return (
    <For each='mod' of={modules} index='idx'>
      <EVEntry {...mod} key={idx} />
    </For>
  )
}
